//
// Copyright (c) 2021 Astute Global, Inc.
//

import { Plugin } from "ckeditor5";
import PrivilegedAreaEditing from "./privilegedAreaEditing";
import PrivilegedAreaUi from "./privilegedAreaUi";

export default class PrivilegedArea extends Plugin {
  static get requires() {
    return [PrivilegedAreaEditing, PrivilegedAreaUi];
  }

  static get pluginName() {
    return "PrivilegedArea";
  }
}
